import { Offcanvas } from 'react-bootstrap'
import QuickSuiteChatEmbed from './QuickSuiteChatEmbed'
import { QuickSuiteChatDrawerProps } from './types'

const CHAT_HEIGHT = '700px'

const QuickSuiteChatDrawer = ({ isOpen, onClose, agentArn }: QuickSuiteChatDrawerProps) => {
  return (
    <Offcanvas show={isOpen} onHide={onClose} placement="end" style={{ width: '500px' }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>AI Assistant</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column p-0" style={{ height: CHAT_HEIGHT }}>
        {isOpen && (
          <div style={{ flex: 1, minHeight: 0 }}>
            <QuickSuiteChatEmbed agentArn={agentArn} />
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default QuickSuiteChatDrawer
